var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPagingRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5l-.67.665L1.48 11 0 9.67 4.184 5.5 0 1.33 1.48 0l4.85 4.835z",
    fill: "#000"
  })));
}

export default SvgPagingRightArrow;